import { Controller } from 'stimulus';

export default class UsersAreSayingController extends Controller {
  static targets = [
    'review',
  ];

  connect() {
    this.setupReadMore();
  }

  setupReadMore() {
    this.reviewTargets.forEach((review) => {
      const innerWrapper = review.querySelector('[data-users-are-saying-target="innerWrapper"]');

      if (innerWrapper.offsetHeight > 72) {
        review.querySelector('[data-users-are-saying-target="readMore"]').classList.remove('is-hidden');
      }
    });
  }

  readMore(event) {
    if (event.currentTarget.classList.contains('is-expanded')) {
      event.currentTarget.innerText = event.currentTarget.dataset.moreText;
    } else {
      event.currentTarget.innerText = event.currentTarget.dataset.hideText;
    }

    event.currentTarget.previousElementSibling.classList.toggle('has-max-height');
    event.currentTarget.classList.toggle('is-expanded');
  }
}
